import { BsWhatsapp } from "react-icons/bs"

export const Duvidas = () => {
    return (
        <a className='cursor-pointer right-1 md:right-4 bottom-5 fixed no-underline z-40' target={"_blank"} rel='noreferrer' href="https://wa.me/553197553622">
            <div className='text-white shadow-md shadow-black p-2 px-3 rounded-full flex-h-between bg-[#34af23] hover:opacity-80 hover:text-white'>
                <div className='flex gap-2 items-center text-sm md:text-lg'>
                    <BsWhatsapp />
                    <span className='font-baloo'>Dúvidas</span>
                </div>
            </div>
        </a>
    )
}